import {
  FETCH_BASIC_ANALYTICS,
  FETCH_PRODUCT_FREQUENCIES
} from 'constants/actionTypes'

const INIT_STATE = {
  basic: [],
  frequencies: []
}

export default (state = INIT_STATE, action) => {
  switch (action.type) {
    case FETCH_BASIC_ANALYTICS:
      let response = action.payload.data
      let pagination = action.payload.pagination
      return {
        ...state,
        basic: response,
        pagination
      }
    case FETCH_PRODUCT_FREQUENCIES:
      response = action.payload.data
      return {
        ...state,
        frequencies: response
      }
    default:
      return { ...state }
  }
}



// WEBPACK FOOTER //
// ./reducers/analytics.js